import script from "./property-info-page.vue?vue&type=script&setup=true&lang=js"
export * from "./property-info-page.vue?vue&type=script&setup=true&lang=js"

import "./property-info-page.vue?vue&type=style&index=0&id=1c301494&scoped=true&lang=css"

import exportComponent from "/Users/timtsang/VueProject/test-2-2/test-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c301494"]])

export default __exports__